import useAppSettingsStore from '@/store/modules/appSettings.js';
import useLocaleStore from '@/store/modules/locale.js';
import { rtlLanguageList } from '@/constants/language.js';

const useThemeHook = () => {
  const appSettingsStore = useAppSettingsStore();
  const localeStore = useLocaleStore();

  const loadStylesheet = (id, href) => new Promise((resolve) => {
    const linkEl = document.getElementById(id);

    if (!linkEl || linkEl.href.endsWith(href)) {
      return resolve();
    }

    const replaceLinkElement = () => {
      const handleEventCallback = () => {
        linkEl.parentNode.removeChild(linkEl);
        resolve();
      };

      const newLinkEl = document.createElement('link');
      newLinkEl.rel = linkEl.rel || 'stylesheet';
      newLinkEl.id = linkEl.id || id;
      newLinkEl.title = linkEl.title || 'EN';
      newLinkEl.href = href;
      newLinkEl.onload = handleEventCallback;
      newLinkEl.onerror = handleEventCallback;

      linkEl.parentNode.insertBefore(newLinkEl, linkEl);
    };

    const updateLinkElement = () => {
      linkEl.href = href;
      linkEl.onload = resolve;
      linkEl.onerror = resolve;
    };

    if (linkEl.href) {
      replaceLinkElement();
    } else {
      updateLinkElement();
    }
  });

  const loadCssFiles = () => {
    const duelSkin = appSettingsStore.appProperties.duelSkin;
    const promiseList = [];

    promiseList.push(loadStylesheet('cssfontsid', '/static/css/fonts.css'));

    if (rtlLanguageList.includes(localeStore.currentLanguage)) {
      promiseList.push(loadStylesheet('cssid', '/static/css/main_AR.css'));
      promiseList.push(loadStylesheet('skinid', `/static/skins/skin_${ duelSkin }/css/skin_AR.css`));
      promiseList.push(loadStylesheet('cssgameid', '/static/css/game_AR.css'));
    } else {
      promiseList.push(loadStylesheet('cssid', '/static/css/main.css'));
      promiseList.push(loadStylesheet('skinid', `/static/skins/skin_${ duelSkin }/css/skin.css`));
      promiseList.push(loadStylesheet('cssgameid', '/static/css/game.css'));
    }

    return Promise.allSettled(promiseList);
  };

  return {
    loadCssFiles,
  };
};

export default useThemeHook;
